var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "36px",
    viewBox: "0 0 39 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cart Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sydney-Opera-House-Workflows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11_Cart",
    transform: "translate(-1362.000000, -41.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(100.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart-Timer",
    transform: "translate(1242.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart-solid",
    transform: "translate(20.000000, 3.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7581342,29.5979785 L38.9589111,15.3792285 C39.1899997,14.3526074 38.4171089,13.375 37.3743326,13.375 L10.7797111,13.375 L10.1590964,10.3118164 C10.0044505,9.54831055 9.33901283,9 8.56706992,9 L1.62500042,9 C0.727526229,9 0,9.73452148 0,10.640625 L0,11.734375 C0,12.6404785 0.727526229,13.375 1.62500042,13.375 L6.3566631,13.375 L11.1130393,36.852002 C9.97513278,37.5126953 9.20833571,38.7515039 9.20833571,40.171875 C9.20833571,42.2860937 10.9059195,44 13,44 C15.0940872,44 16.791671,42.2860937 16.791671,40.171875 C16.791671,39.1004102 16.3551553,38.132373 15.6525457,37.4375 L29.8473983,37.4375 C29.1448565,38.132373 28.7083407,39.1004102 28.7083407,40.171875 C28.7083407,42.2860937 30.4059245,44 32.5,44 C34.5940923,44 36.291676,42.2860937 36.291676,40.171875 C36.291676,38.6562109 35.4190508,37.3464453 34.153514,36.7262207 L34.527061,35.0667285 C34.7581496,34.0401074 33.9852588,33.0625 32.9424825,33.0625 L14.7683424,33.0625 L14.3251912,30.875 L34.1735557,30.875 C34.9322955,30.875 35.5900144,30.3449414 35.7581342,29.5979785 Z",
    id: "Cart-Icon"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart_icon.27ab0624b91565258795ffb0f78160d8.svg";
export { ForwardRef as ReactComponent };